module.exports = __webpack_public_path__ + "img/ru9.ca8ddc3c.jpg";